<template>
  <v-text-field
      ref="inputRef"
      variant="solo"
      hideDetails="auto"
      flat
      :label="label ? $t(label) : label"
      :model-value="formattedValue"
      :rules="rulesWrap"
      :required="required"
      :disabled="disabled"
      :readonly="readonly"
      :messages="hintMessage"
      @update:model-value="onInput"
  ></v-text-field>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useCurrencyInput } from 'vue-currency-input';

const props = defineProps({
  label: String,
  disabled: Boolean,
  value: Number,
  rules: Array,
  required: Boolean,
  readonly: Boolean,
  message: Function,
});

const emit = defineEmits(['input', 'change']);

const formattedValue = ref(null);
const realValue = ref(null);
const hintMessage = ref('');

const options = {
  locale: 'RU',
  currency: 'USD',
  precision: 2,
  distractionFree: false,
  allowNegative: false,
  valueRange: {
    min: 0,
  }
};

const { inputRef, setValue } = useCurrencyInput(options, false);

const rulesWrap = computed(() => {
  if (!props.rules) return [];

  return props.rules.map((f) => () => f(realValue.value));
});

const onInput = (value) => {
  emit('input', value);

  formattedValue.value = value;
  realValue.value = value;
  hintMessage.value = props.message ? props.message(realValue.value) : '';
};

watch(
    () => props.modelValue,
    (value) => {
      setValue(value);
    },
);

onMounted(() => {
  setValue(props.value);
});
</script>
<style scoped>
:deep(.v-field) {
  border-radius: 8px;
}

:deep(.v-field__input) {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgb(var(--input-text-color));
}

:deep(.v-field__outline) {
  border: 1px solid rgb(var(--border-color));
  border-radius: 8px;
  color: rgb(var(--boulder-color));
}

:deep(.v-field--error:not(.v-field--disabled) .v-field__outline) {
  border: 1px solid rgb(var(--error-color));
}

:deep(.v-input__details) {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  padding-inline: 0;
}

:deep(.v-field-label--floating) {
  opacity: 1;
}

:deep(.v-field--variant-solo) {
  color: rgb(var(--gunsmoke-color));
}

:deep(.v-field--variant-solo.v-field--dirty) {
  color: rgb(var(--input-text-color));
}
</style>
